import React from 'react';
import { Alert } from 'antd';
import ReactTable from 'react-table';
import { useGetEmailQueueWatcher } from 'query/mail';
import UserWithAvatar from 'components/ui/UserWithAvatar';
import WatchOrUnwatchEmailQueueButton from './WatchOrUnwatchEmailQueueButton';
import { useGetCurrentProfile } from '../../../query/user';
import AddEmailQueueWatcherButton from './AddEmailQueueWatcherButton';
import RemoveEmailWatcherButton from './RemoveEmailWatcherButton';

export default function EmailQueueMonitoring() {
  const { data: userData } = useGetCurrentProfile();
  const { data = [], isLoading } = useGetEmailQueueWatcher();
  return (
    <div className="space-y-2">
      <Alert
        message={
          <div>
            By watching email queue. You will be notified when email requests or
            messages are stuck in the queue for too long
            <ul style={{ marginTop: 5 }}>
              <li style={{ paddingBottom: 0 }}>
                An email request is a batch of emails, maximum emails in one
                batch is 500. Email requests will be processed into individual
                email messages
              </li>
              <li style={{ paddingBottom: 0 }}>
                An email message is an email that will be sent to a recipient
              </li>
            </ul>
          </div>
        }
        showIcon
        type="info"
      />
      <div className="w-full space-x-2">
        <WatchOrUnwatchEmailQueueButton
          isWatching={data.find(e => e.user.id === userData?.id)}
        />
        <AddEmailQueueWatcherButton />
      </div>
      <ReactTable
        columns={[
          {
            Header: 'User',
            id: 'owner',
            accessor: row => {
              return <UserWithAvatar user={row.user} />;
            },
          },
          {
            Header: '',
            id: 'actions',
            accessor: row => {
              if (row.user.id === userData?.id) {
                return null;
              }
              return <RemoveEmailWatcherButton userId={row.user.id} />;
            },
            maxWidth: 300,
          },
        ]}
        data={data || []}
        firstText={<i className="material-icons">first_page</i>}
        lastText={<i className="material-icons">last_page</i>}
        loading={isLoading}
        minRows={0}
        nextText={<i className="material-icons">chevron_right</i>}
        previousText={<i className="material-icons">chevron_left</i>}
        showPagination
        showPaginationBottom
      />
    </div>
  );
}
